(function () {
  var form = document.getElementById('aboutSignupForm');
  var emailInput = document.getElementById('aboutEmailInput');
  var submitButton = document.getElementById('aboutSubmitButton');
  var errorMessage = document.getElementById('aboutErrorMessage');
  var errorText = document.getElementById('aboutErrorText');
  var successState = document.getElementById('aboutSuccess');
  if (!form || !emailInput || !submitButton || !errorMessage || !errorText || !successState) return;

  // Shopify's bot protection hooks the customer form submit to attach a captcha
  // token, so a real storefront post must stay a normal navigation. The static
  // preview has no backend and simulates the same states.
  var isShopify = form.hasAttribute('data-shopify');
  var isSubmitting = false;
  var subscribedEmails = new Set();

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function reveal(el) {
    if (!el || !el.getBoundingClientRect) return;
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top < 0 || rect.bottom > vh) {
      el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  function showError(message) {
    errorText.textContent = message;
    errorMessage.hidden = false;
    emailInput.setAttribute('aria-invalid', 'true');
    emailInput.setAttribute('aria-describedby', 'aboutErrorMessage');
    reveal(errorMessage);
  }

  function clearError() {
    if (!errorMessage.hidden) {
      errorMessage.hidden = true;
      emailInput.removeAttribute('aria-invalid');
      emailInput.removeAttribute('aria-describedby');
    }
  }

  function setLoading(loading) {
    isSubmitting = loading;
    emailInput.readOnly = loading;
    submitButton.disabled = loading;
    submitButton.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function trackSignup(email) {
    try {
      if (typeof gtag === 'function') {
        gtag('event', 'sign_up', { method: 'Early Access Waitlist' });
      }
      if (typeof fbq === 'function') {
        fbq('track', 'Lead', { content_name: 'Early Access Waitlist' });
      }
    } catch (err) {
      console.warn('Analytics event dispatch error:', err);
    }
    if (!email) return;
    try {
      window.dispatchEvent(new CustomEvent('sunok:subscribed', { detail: { email: email } }));
      if (window._learnq) {
        window._learnq.push(['identify', { $email: email }]);
        window._learnq.push(['track', 'Signed Up for Waitlist', { email: email }]);
      }
      if (window.klaviyo) {
        window.klaviyo.identify({ email: email });
      }
    } catch (kErr) {
      console.warn('Klaviyo event dispatch error:', kErr);
    }
  }

  function showSuccess(email) {
    subscribedEmails.add(email);
    trackSignup(email);
    form.hidden = true;
    successState.hidden = false;
    reveal(successState);
  }

  emailInput.addEventListener('input', clearError);

  form.addEventListener('submit', function (e) {
    if (!isShopify || isSubmitting) e.preventDefault();
    if (isSubmitting) return;

    var email = emailInput.value.trim().toLowerCase();
    if (!email || !isValidEmail(email)) {
      e.preventDefault();
      showError('Please enter a valid email address.');
      emailInput.focus();
      return;
    }
    if (subscribedEmails.has(email)) {
      e.preventDefault();
      showError("You're already on the list.");
      emailInput.focus();
      return;
    }

    emailInput.value = email;
    clearError();
    setLoading(true);

    if (isShopify) {
      try { sessionStorage.setItem('sunok:pendingEmail', email); } catch (err) {}
    } else if (email.endsWith('@bad.com') || email.endsWith('@error.com')) {
      e.preventDefault();
      setTimeout(function () {
        setLoading(false);
        showError('Something went wrong - please try again.');
        emailInput.focus();
      }, 300);
    } else {
      e.preventDefault();
      setTimeout(function () {
        setLoading(false);
        showSuccess(email);
      }, 300);
    }
  });

  var initialState = form.querySelector('[data-signup-state]');
  if (initialState && initialState.getAttribute('data-posted') === 'true' && /customer_posted=true/.test(window.location.search)) {
    var pendingEmail = null;
    try {
      pendingEmail = sessionStorage.getItem('sunok:pendingEmail');
      sessionStorage.removeItem('sunok:pendingEmail');
    } catch (err) {}
    trackSignup(pendingEmail);
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) setLoading(false);
  });
})();
